<template>
    <div class="pb-2">
        <div
            v-for="(message, index) in messages"
            :key="index"
            class="d-flex p-1"
            :class="{ 'justify-content-end': message.type === 'learner' }"
        >
            <div
                v-if="message.type === 'learner'"
                class="py-2 px-3 alert alert-primary border-0 ml-5 whitespace-pre message"
            >{{ message.content }}</div>
            <div v-else>
                <div class="mr-5 position-relative">
                    <div class="audio-icon d-flex justify-content-end">
                        <span
                            class="icon icon-glyphicons-basic-volume-up"
                            :class="{ 'opacity-0': !message.audioPlaying }"
                        ></span>
                    </div>
                    <div class="py-2 px-3 rounded-lg bg-light message">
                        <div v-show="message.isThinking">
                            <div class="d-flex align-items-center chat-dot-container">
                                <div class="chat-dot chat-dot-1"></div>
                                <div class="chat-dot chat-dot-2"></div>
                                <div class="chat-dot chat-dot-3"></div>
                            </div>
                        </div>
                        <div v-show="!message.isThinking">
                            {{ message.content }}
                        </div>
                        <div class="d-none" v-if="enableAudio && message.audio">
                            <audio
                                :autoplay="!message.audioPlaying && !message.audioCompleted"
                                :src="message.audio.signed_url"
                                @ended="audioEnded(message)"
                                @play="audioStarted(message)"
                            ></audio>
                        </div>
                    </div>
                    <div v-if="message.intents_discovered" class="discovered-items d-flex justify-content-end">
                        <span
                            v-for="intentDiscovered in message.intents_discovered"
                            :key="intentDiscovered.id"
                            class="badge badge-pill badge-tiny"
                            :class="{
                                'animate-delay': intentDiscovered.isNewDiscovery,
                                'correct-icon-animate': intentDiscovered.isNewDiscovery && intentDiscovered.correct,
                                'incorrect-icon-animate':
                                    intentDiscovered.isNewDiscovery && intentDiscovered.correct === false,
                                'badge-success': intentDiscovered.correct,
                                'badge-danger': intentDiscovered.correct === false,
                            }"
                            ref="popover"
                        >
                            <span
                                class="icon icon-100 align-middle mr-xs"
                                :class="{
                                    'icon-glyphicons-basic-check': intentDiscovered.correct === true,
                                    'icon-glyphicons-basic-menu-close': intentDiscovered.correct === false,
                                }"
                            ></span>
                            <span class="align-middle">{{ intentDiscovered.message }}</span>
                        </span>
                    </div>
                    <div
                        v-if="
                            message.intents_discovered &&
                            message.intents_discovered.filter((i) => i.chat_agent_intent.feedback_message).length > 0
                        "
                        class="p-2 mt-2 mb-1 rounded-lg instructor-message"
                        :class="{ 'delayed-fade-in': index === messageCount - 1 }"
                    >
                        <div class="mb-2 text-secondary">
                            <span class="align-middle">💡 {{ labelsTranslated.instructorFeedback }}</span>
                        </div>
                        <div
                            class="mb-1 ml-1 whitespace-pre"
                            v-for="intentDiscovered in message.intents_discovered"
                            :key="intentDiscovered.id"
                        >{{ intentDiscovered.chat_agent_intent.feedback_message }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ChatConversation",
    props: {
        messages: {
            type: Array,
            required: false,
            default() {
                return []
            },
        },
        enableAudio: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: {
        labelsTranslated() {
            return this.$store.getters.sessionLabelsTranslated
        },
        messageCount() {
            return this.messages.length
        },
    },
    methods: {
        audioEnded(message) {
            this.$emit("video-complete")
            this.$set(message, "audioPlaying", false)
            this.$set(message, "audioCompleted", true)
        },
        audioStarted(message) {
            this.$set(message, "audioPlaying", true)
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/chat.scss";

.discovered-items {
    position: relative;
    top: -10px;
    margin-bottom: -10px;
    .badge {
        font-weight: 500;
        margin-left: 2px;
    }
}

.message {
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 1rem !important;
}

.instructor-message {
    background-color: #f3f6fa;
    font-size: 13px;
}

.audio-icon {
    position: absolute;
    top: -8px;
    right: -8px;
    .icon {
        font-size: 24px;
        transition: opacity 0.25s ease-in-out;
    }
    animation: fadeInOut 1s infinite;
}

@keyframes fadeInOut {
    0%,
    100% {
        opacity: 0.4;
    }
    50% {
        opacity: 1;
    }
}

.opacity-0 {
    opacity: 0 !important;
}

.delayed-fade-in {
    opacity: 0;
    animation: fadeIn 0.35s ease-out 0.2s forwards;
}

@keyframes fadeIn {
    from {
        opacity: 0.4;
    }
    to {
        opacity: 1;
    }
}
</style>